import type { LoadBetDetails } from '@core/Areas/ShareBet/LoadBet/types'
import { get, post } from '@core/Services/ApiService'

export const postShareBetDataAndGenerateLink = (
  bets: LoadBetDetails[]
): Promise<{ message: string; link: string }> => {
  return post({
    url: '/api/sharebet/share-bet',
    body: { data: bets },
  })
}

export const getShareBetDataWithKey = (
  key: string,
  accountNumber: number | null
): Promise<{ message: string; key: string; data: LoadBetDetails[]; accountNumber: string }> => {
  return get({
    url: `/api/sharebet/share-bet?key=${key}&retrievingAccountId=${accountNumber}`,
  })
}
